module.exports = new __parcel__URL__("snare_5.81e6e076.mp3").toString();